const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 clamp(1rem, 5vw, 5.6rem)',
    backgroundColor: '#000',
    color: '#FFF',
    maxWidth: '1440px',
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 'clamp(2rem, 5vw, 5rem)',
    width: '100%',
  },
  title: {
    fontSize: 'clamp(2rem, 4vw, 3.12rem)',
    fontFamily: 'Orbitron, sans-serif',
    marginBottom: 'clamp(0.5rem, 2vw, 1rem)',
  },
  largeCardContainer: {
    position: 'relative',
    width: 'clamp(30rem, 50vw, 45rem)',
    height: 'clamp(12rem, 25vw, 18.37rem)',
    marginLeft: 'clamp(1rem, 5vw, 4.5rem)',
  },
  largeCardOuterBorder: {
    position: 'absolute',
    width: 'calc(clamp(30rem, 50vw, 45rem) + 1px)',
    height: 'calc(clamp(12rem, 25vw, 18.37rem) + 3px)',
    borderRadius: '0 50px 50px 0',
    background:
      'linear-gradient(to bottom left, rgba(217, 217, 217, 0.4) 0%, rgba(217, 217, 217, 0.1) 100%)',
    zIndex: 1,
  },
  largeCardWrapper: {
    position: 'relative',
    width: 'clamp(30rem, 50vw, 45rem)',
    height: 'clamp(12rem, 25vw, 18.37rem)',
    overflow: 'hidden',
    borderRadius: '0 50px 50px 0',
    marginTop: 'clamp(0.05rem, 0.2vw, 0.08rem)',
  },
  verticalBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '2px',
    height: '100%',
    backgroundColor: '#D9D9D9',
    opacity: 0.8,
    zIndex: 5,
  },
  cardImage: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 2,
  },
  cardBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(100px)',
    zIndex: 3,
  },
  cardBlurHover: {
    animation: 'blurAnimation 4s infinite ease-in-out',
  },
  largeCardContent: {
    position: 'relative',
    zIndex: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 'clamp(1rem, 4vw, 2.2rem) clamp(2rem, 5vw, 4rem)',
  },
  largeCardTitle: {
    fontSize: 'clamp(1rem, 2vw, 1.5rem)',
    color: '#D9D9D9',
    marginTop: '0',
    marginBottom: 'clamp(0.5rem, 2vw, 1.5rem)',
  },
  largeCardText: {
    lineHeight: '1.8',
    color: 'rgba(217, 217, 217, 0.7)',
    marginTop: '0',
    marginBottom: '0',
  },
  cardsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'clamp(0.8rem, 2vw, 1.5rem)',
    flexWrap: 'wrap',
    width: '100%',
  },
  cardOuterBorder: {
    position: 'relative',
    width: 'calc(clamp(18rem, 30vw, 25rem) + 1px)',
    // minHeight: 'calc(clamp(10rem, 20vw, 15.65rem) + 2px',
    height: '(clamp(10rem, 30vw, 15.65rem) + px',
    borderRadius: '25px',
    // background:
    //   'linear-gradient(to bottom left, rgba(217, 217, 217, 0.4) 0%, rgba(217, 217, 217, 0.1) 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
  card: {
    position: 'relative',
    width: 'clamp(18rem, 30vw, 25rem)',
    // minHeight: 'clamp(10rem, 20vw, 15.65rem)',
    height: 'clamp(10rem, 20vw, 15.65rem)',
    border: "0.8px solid rgba(200, 200, 200, 0.4)",
    borderRadius: '25px',
    overflow: 'hidden',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    zIndex: 2,
  },
  cardContent: {
    position: 'relative',
    zIndex: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: 'clamp(1rem, 3vw, 1.5rem)',
  },
  cardIcon: {
    width: 'clamp(1.5rem, 3vw, 2rem)',
    height: 'auto',
    marginBottom: 'clamp(1rem, 5vw, 3rem)',
  },
  cardTitle: {
    fontSize: 'clamp(1.2rem, 3vw, 2rem)',
    fontWeight: '400',
    fontFamily: 'Orbitron, sans-serif',
    marginBottom: 'clamp(0.5rem, 2vw, 1rem)',
    marginTop: '0',
  },
  cardText: {
    fontSize: 'clamp(0.9rem, 2vw, 1rem)',
    opacity: 0.5,
    marginTop: '0',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
  },  
};

export default styles;
